class MobileGenderTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-panel]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.select(tab.dataset.tab));
    });

    let saved = null;
    try {
      saved = window.localStorage.getItem('fr-mobile-gender-tab');
    } catch (error) {
      saved = null;
    }

    if (saved === 'women' || saved === 'men') {
      this.select(saved, false);
    }
  }

  select(name, persist = true) {
    this.tabs.forEach((tab) => {
      tab.setAttribute('aria-selected', tab.dataset.tab === name ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.panel !== name;
    });

    if (persist) {
      try {
        window.localStorage.setItem('fr-mobile-gender-tab', name);
      } catch (error) {
        /* localStorage unavailable, ignore */
      }
    }
  }
}

if (!customElements.get('mobile-gender-tabs')) {
  customElements.define('mobile-gender-tabs', MobileGenderTabs);
}
